import { P as sleep, aW as noop_1 } from './index-39f51a91.js';

const timeLimitedRequest = (func, ms = 5000) => (...args) => {
  return Promise.race([func(...args), sleep(ms)]).catch(noop_1);
};
const getMyProductsFromConnector = async () => {
  let resolve = noop_1;
  const onSucceeded = (event) => {
    resolve(event.detail);
  };
  try {
    const myProductsPromise = new Promise((res) => {
      resolve = res;
      document.addEventListener('pesGetMyProductsSucceeded', onSucceeded);
      document.dispatchEvent(new CustomEvent('pesGetMyProducts'));
    });
    const timeoutPromise = sleep(10000).then(() => null);
    return await Promise.race([myProductsPromise, timeoutPromise]);
  }
  finally {
    document.removeEventListener('pesGetMyProductsSucceeded', onSucceeded);
  }
};

export { getMyProductsFromConnector as g, timeLimitedRequest as t };
